import styled from 'styled-components';
import { ButtonDarkHighlighted } from '../../components/shared/Buttons';
import { FlexRowMiddle } from '../../components/shared/Flex';
import { panelHeaderTop, tablePaddingSide } from '../../components/shared/Table';

const StyledQuaterSelection = styled(FlexRowMiddle)`
	padding: ${panelHeaderTop} ${tablePaddingSide};
	column-gap: 1rem;
`;

const StyledQuaterSeperator = styled.div`
	background-color: ${({ theme }) => theme.border};
	width: 1px;
	height: 30px;
`;

const quaterIds = [
	{ id: 'uncategorized', text: 'Uncategorized' },
	{ id: '2026-q1', text: 'Q1 2026' },
	{ id: '2026-q2', text: 'Q2 2026' },
	{ id: '2026-q3', text: 'Q3 2026' },
	{ id: '2026-q4', text: 'Q4 2026' },
];

export function SalesQuaterSelection({
	quaterId,
	selectQuaterId,
}: {
	quaterId: string;
	selectQuaterId: (quaterId: string) => void;
}) {
	return (
		<StyledQuaterSelection>
			{quaterIds.map((qId, index) => {
				return (
					<>
						<ButtonDarkHighlighted
							$focus={qId.id === quaterId}
							onClick={() => selectQuaterId(qId.id)}
							key={`quater-button-${qId.id}`}
						>
							{qId.text}
						</ButtonDarkHighlighted>
						{index === 0 && <StyledQuaterSeperator />}
					</>
				);
			})}
		</StyledQuaterSelection>
	);
}
